import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import FAQSection from '@/pages/home/components/FAQSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import RankingSection from '@/pages/home/components/RankingSection';
import ContactSection from '@/pages/home/components/ContactSection';
import MediaSection from '@/pages/home/components/MediaSection';
import CardsSection from '@/pages/home/components/CardsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FAQSection />
        <FeaturesSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
        <RankingSection />
        <ContactSection />
        <MediaSection />
        <CardsSection />
        <CarouselSection />
        <UpdatesSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}